export default "__VITE_ASSET__xdvACM_s__"